<div class="audience-shell">
  <header class="audience-header">
    <div class="audience-header__title-group">
      <h1>Target Audience Profiles</h1>
      <ng-container *ngIf="hasPendingGenerations(); else viewGeneratedButton">
        <button
          type="button"
          class="button button--primary"
          (click)="generateAllTargetAreas()"
          [disabled]="bulkGenerationPending()"
        >
          All Generate Target Areas
        </button>
      </ng-container>
      <ng-template #viewGeneratedButton>
        <button
          type="button"
          class="button button--primary"
          (click)="viewAllGeneratedTargetAreas()"
          [disabled]="bulkGenerationPending() || viewAllPending()"
        >
          <ng-container *ngIf="!viewAllPending(); else viewAllLoading">
            View All Generated Target Areas
          </ng-container>
        </button>
        <ng-template #viewAllLoading>
          <span class="spinner">
            <span class="spinner__dot"></span>
            <span>Loading...</span>
          </span>
        </ng-template>
      </ng-template>
    </div>
    <div class="audience-header__actions">
      <button type="button" class="button button--secondary" [routerLink]="['/']">
        Back to Form
      </button>
    </div>
  </header>

  <section class="audience-status">
    <span class="status status--info" *ngIf="loading()">
      <span class="spinner__dot"></span>
      <span>Preparing audience profiles...</span>
    </span>
    <span class="status status--success" *ngIf="!loading() && statusMessage()">
      {{ statusMessage() }}
    </span>
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
  </section>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">›</span>
    <span>Target Audience Profiles</span>
  </nav>

  <section class="audience-table-wrapper" *ngIf="audiences().length && !loading(); else emptyState">
    <table class="audience-table">
      <thead>
        <tr>
          <th>Audience</th>
          <th>Audience Type</th>
          <th>Market Type</th>
          <th>Company Size</th>
          <th>Industries</th>
          <th>Decision Makers</th>
          <th>Locations</th>
          <th>Market Size Estimate</th>
          <th>Priority Level</th>
          <th class="audience-table__actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audience of audiences()">
          <td>
            <div class="audience-table__name">
              <div class="audience-table__details">
                <span class="audience-table__title">
                  {{ audience.target_audience || 'Untitled Audience' }}
                </span>
                <span class="audience-table__subtitle">
                  {{ audience.audience_type ? (audience.audience_type | titlecase) : 'Audience' }}
                </span>
              </div>
            </div>
          </td>
          <td>{{ audience.audience_type || 'N/A' }}</td>
          <td>{{ audience.market_type || 'N/A' }}</td>
          <td>{{ renderText(audience.company_size) }}</td>
          <td>
            <ng-container *ngIf="renderArray(audience.industries) as industries">
              {{ industries.length ? industries.join(', ') : 'N/A' }}
            </ng-container>
          </td>
          <td>
            <ng-container *ngIf="renderArray(audience.decision_makers) as makers">
              {{ makers.length ? makers.join(', ') : 'N/A' }}
            </ng-container>
          </td>
          <td>{{ renderText(audience.locations) }}</td>
          <td>{{ renderText(audience.market_size_estimate) }}</td>
          <td>{{ renderText(audience.priority_level) }}</td>
          <td class="audience-table__actions">
            <button type="button" class="button button--primary button--small" (click)="viewDetails(audience)">
              View Details
            </button>
            <button
              type="button"
              class="button button--accent button--small"
              (click)="handleTargetAreaAction(audience)"
              [disabled]="isGenerating(audience) || bulkGenerationPending()"
            >
              <ng-container *ngIf="!isGenerating(audience); else pending">
                {{ targetAreaActionLabel(audience) }}
              </ng-container>
            </button>
            <div class="audience-table__status" *ngIf="generationInfo(audience.id) as info">
              <span
                class="status"
                [class.status--success]="!info.isError"
                [class.status--error]="info.isError"
              >
                {{ info.text }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <ng-template #pending>
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Generating...</span>
    </span>
  </ng-template>

  <ng-template #emptyState>
    <p class="audience-empty">
      No target audience profiles are available yet. Submit the product or service summary to generate insights.
    </p>
  </ng-template>
</div>
